import Controller from "./city.controller";
import template from "./city.html";

const city = {
  template,
  controller: Controller,
};

export default city;



// WEBPACK FOOTER //
// ./src/pages/city/city.component.js